import * as hooks from "lib/hooks"
import { motion } from "framer-motion"
import { FormHelperText } from "@mui/material"

export function ErrorMessage({ msg }: { msg: string }) {
	const { theme } = hooks.UseTheme()
	return (
		<motion.div
			initial={{ opacity: 0, y: -5 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.2, type: "spring", stiffness: 500 }}
		>
			<FormHelperText
				sx={{
					color: theme.palette.error.main,
					ml: 1,
					fontWeight: 600,
					fontSize: "0.8rem",
					mt: 0.5,
					letterSpacing: "0.01em",
				}}
			>
				{msg}
			</FormHelperText>
		</motion.div>
	)
}
